import * as _ from 'underscore';
const csv=require('csvtojson')

export class PagerService {
    messageImage;
    //make Pagination
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
        // calculate total pages
        let totalPages;

        if(totalItems == 0){
            totalPages = 1;
        }else{
            totalPages = Math.ceil(totalItems / pageSize);
        }

        let startPage: number, endPage: number;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = _.range(startPage, endPage + 1);

        // limit pagination only display 3 pages
        const displayPages = this._getDisplayPages(currentPage, pages, startPage, endPage);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages,
            displayPages : displayPages
        };
    }

    // make an array of display only 3 pages 
    _getDisplayPages(current, pages, start, end) {
        const resultPages = [];
        const idxCurrent = pages.indexOf(current);
        
        if (current === 1) {
            resultPages.push(current);
            if (pages[idxCurrent + 1] != undefined) resultPages.push(pages[idxCurrent + 1]);
            if (pages[idxCurrent + 2] != undefined) resultPages.push(pages[idxCurrent + 2]);
        } else if (current === end) {
            if (pages[idxCurrent - 2] != undefined) resultPages.push(pages[idxCurrent - 2]);
            if (pages[idxCurrent - 1] != undefined) resultPages.push(pages[idxCurrent - 1]);
            resultPages.push(current);
        } else {
            resultPages.push(pages[idxCurrent - 1]);
            resultPages.push(current);
            resultPages.push(pages[idxCurrent + 1]);
        }

        return resultPages;
    }

    //Make sorting
    getSorting(array, orderBy, asc = true, typeSort = ""){
        if (!orderBy || orderBy.trim() == ""){
          return array;
        } 
        var multipleArr = orderBy.split(".");
        if(multipleArr.length == 1){
            //ascending
            if (asc){
                return Array.from(array).sort((item1: any, item2: any) => {
                    return this.orderByComparator(item1[orderBy], item2[orderBy]);
                });
            }
            else{
            //not asc
                return Array.from(array).sort((item1: any, item2: any) => { 
                    return this.orderByComparator(item2[orderBy], item1[orderBy]);
                });
            }
        }else if(multipleArr.length == 2){
            if (typeSort == "date") {
                return array.sort(this.getSortingNullLast(asc, multipleArr));
            } else {
                //ascending
                if (asc){
                    return Array.from(array).sort((item1: any, item2: any) => { 
                        return this.orderByComparator(item1[multipleArr[0]][multipleArr[1]], item2[multipleArr[0]][multipleArr[1]]);
                    });
                }
                else{
                //not asc
                    return Array.from(array).sort((item1: any, item2: any) => { 
                        return this.orderByComparator(item2[multipleArr[0]][multipleArr[1]], item1[multipleArr[0]][multipleArr[1]]);
                    });
                }
            }
        }
    }
    // make sorting for NULL/UNDEFINED value in the last of the array (RIGHT NOW TESTED ON DATE)
    getSortingNullLast(asc, multipleArr) {
        return function(a,b){ 
        a = a[multipleArr[0]][multipleArr[1]];
        b = b[multipleArr[0]][multipleArr[1]];
        if(a === null || a === undefined){
          return 1;
        }
        else if(b === null || b === undefined){
          return -1;
        }
        else if(a === b){
          return 0;
        }
        else if(asc) {
          return a < b ? -1 : 1;
        }
        else if(!asc) {
          return a < b ? 1 : -1;
        }
      };
    }

    //order Sorting
    orderByComparator(a:any, b:any):number {
        if((a !== null && a !== undefined) && (b !== null && b !== undefined)) {
            if((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
            //Isn't a number so lowercase the string to properly compare
                if(this.checkFormatDate(a) || this.checkFormatDate(b)){
                    if(a < b) return -1;
                    if(a > b) return 1;  
                } else {
                    // console.log(a.toLowerCase() + ":" + b.toLowerCase() + ":" + (a.toLowerCase() < b.toLowerCase()));
                    if(a.toLowerCase() < b.toLowerCase()) return -1;
                    if(a.toLowerCase() > b.toLowerCase()) return 1;  
                }
            } else {
              //Parse strings as numbers to compare properly
              if(parseFloat(a) < parseFloat(b)) return -1;
              if(parseFloat(a) > parseFloat(b)) return 1;
            }

            return 0; //equal each other
        } else {
            return 0;
        }
    }

    checkFormatDate(date) {
        var parms = date.split(/[\.\-\/]/);
        var yyyy = parseInt(parms[0],10);
        var mm   = parseInt(parms[1],10);
        var dd   = parseInt(parms[2],10);
        var dateCheck = new Date(yyyy,mm-1,dd,0,0,0,0);
        return mm === (dateCheck.getMonth()+1) && dd === dateCheck.getDate() && yyyy === dateCheck.getFullYear();

        // var parsedDate = Date.parse(date);
        // if (isNaN(date) && !isNaN(parsedDate)) {
        //     return true;
        // }else{
        //     return false;
        // }
    }
    //formating date
    formatDate(date){
        var sepDate = new Date(date);
        var year = sepDate.getFullYear();
        var month = sepDate.getMonth() + 1;
        
        var printMonth :string;
        var printDays : string;

        if( month < 10){
            printMonth = "0" + month;
         }else{
            printMonth = "" + month;
         }
         var days = sepDate.getDate();
         if( days < 10){
            printDays = "0" + days;
         }else{
            printDays = "" + days;
         }
         
        // console.log(dateSep);    q
         return year + "年" + printMonth + "月" + printDays + "日";
        
    }
    
    //formating date
    formatDateSet2(date){
            var sepDate = new Date(date);
            var year = sepDate.getFullYear();
            var month = sepDate.getMonth() + 1;
            
            var printMonth :string;
            var printDays : string;
    
            if( month < 10){
                printMonth = "0" + month;
             }else{
                printMonth = "" + month;
             }
             var days = sepDate.getDate();
             if( days < 10){
                printDays = "0" + days;
             }else{
                printDays = "" + days;
             }
             
            // console.log(dateSep);
    
             return year + "/" + printMonth + "/" + printDays;
            
        }


        formatDate3(date){
            var sepDate = new Date(date);
            var year = sepDate.getFullYear();
            var month = sepDate.getMonth() + 1;
            
            var printMonth :string;
            var printDays : string;
    
            if( month < 10){
                printMonth = "0" + month;
             }else{
                printMonth = "" + month;
             }
             var days = sepDate.getDate();
             if( days < 10){
                printDays = "0" + days;
             }else{
                printDays = "" + days;
             }
             
            // console.log(dateSep);    q
             return year + "-" + printMonth + "-" + printDays ;
            
        }
    //Generate data
    generateDate(Year, Month, Day){
        var date;
        if( Month < 10){
            Month = "0" + Month;
         }else{
            Month = "" + Month;
         }
         if( Day < 10){
            Day = "0" + Day;
         }else{
            Day = "" + Day;
         }
        date = Year + '-' + Month + '-' + Day;
         console.log(date);
        return date;
    }
    //Getting day data
    getDay(date){
        if(date == "0000-00-00 00:00:00" ||　date.length < 10){
            return "";
        }else{
            date = date.substring(0, 10);
            var sepDate = new Date(date);
            var days = sepDate.getDate();
            return  days;
        }
    }
    //getting month from date
    getMonth(date){
        if(date == "0000-00-00 00:00:00"  ||　date.length < 10){
            return "";
        }else{
            
            date = date.substring(0, 10);
            var sepDate = new Date(date);
            
            var month = sepDate.getMonth() + 1;
    
             return  month;
        }

        
    }
    //getting year from date
    getYear(date){
        if(date == "0000-00-00 00:00:00"  ||　date.length < 10){
            return "";
        }else{
            
            date = date.substring(0, 10);
            var sepDate = new Date(date);
            var year = sepDate.getFullYear();
    
             return  year;  
        }        
 
    }

    combineDate(Year, Month, Day){
        return Year + '-' + Month + '-' + Day;
    }
    
    dateIsValid(date){
        if(date.length >= 10){
            date = date.substring(0, 10);
            date = new Date(date);

            if(!date || isNaN(date.getTime())){
                return false;
            }
            else{
                return true;
            } 
        }else{
            return false;
        }
    }

    //checking public for image from date
    checkImage(imageData){
        var re = new RegExp("image/*");
        const isImageSvg = imageData.type === 'image/svg+xml' ? true : false;
        const isImageGif = imageData.type === 'image/gif' ? true : false;

        if(imageData.size > 2000000){
            this.messageImage = "イメージのファイルサイズが２MBを超えています。";
            return false;
        }else{
            if (re.test(imageData.type) && !isImageSvg && !isImageGif) {
                this.setImageData(imageData , data => {
                    var ratio = data.width / data.height;
                    console.log(ratio);
                    if(ratio !== 4){
                        this.messageImage = "イメージの推奨解像度は４：１（幅：高さ）です。";                        
                    }else{
                        this.messageImage = "";                        
                    }
                   
                });
                return true;
            } else {
                // this.messageImage = "ファイル形式が不正です。";
                this.messageImage = "イメージの種類を入力してください：jpeg、jpg、png";
                return false;
            }    
        }
    }

    checkImagesize(imageData, callback){
        var image = new Image();
        image.src = imageData;
        image.onload = function() {
            var result = {
                width : image.width,
                height : image.height
            }
            callback(result);
        };
     
    }
    setImageData(imageData , callback){
        let reader = new FileReader();
  
        reader.onload = (e: any) => {
          this.checkImagesize(e.target.result , callback);
        }
    
        reader.readAsDataURL(imageData);
    }
    //public event status for job
    //get status
    getStatus(status){
        return status ? '終了' : '募集中';
    }

    //Identify Event status
    filters = [
        { "id": "-1", "name": "すべて"},
        { "id": "0", "name": "受付中"},
        { "id": "1", "name": "終了"},
        { "id": "2", "name": "作成中"}
    ];

    event_statuses = [ 
        { "id": "0", "name": "受付中"},
        { "id": "1", "name": "終了"},
        { "id": "2", "name": "作成中"}
    ];

    getEventStatus(status){
        var print_value = '';
        
        var count ;
        count = this.filters.length;
        for(var i = 0; i < count ; i++){
            if(this.filters[i].id == status){
                print_value = this.filters[i].name;
            }
        }
        return print_value;
    }

    getFilters(){
        return this.filters
    }

    getEventStatusList(){
        return this.event_statuses;
    }

    deleteSorting(arr1, arr2, id, arrSelect){
        var total;
        var totalAll ;
        var totalSel;
        var boolean = 0 ;
        total = arr1.length;

    
        for (var i = 0; i < total; i++){
          if(arr1[i].id == id){
            if((i + 1) < total){
                arr1.splice(i,1); 
                break;
            }

            else{
                arr1.pop();
            }
          }
        }
        
        totalAll = arr2.length;
        for (var i = 0; i < arr2.length; i++){
          if(boolean == 1 && total > 10 && arr2[i].id != id){
            arr1.push(arr2[i]);
            boolean = 0;
          }else{
            if(arr1.length > 1 ){
                if(arr2[i].id == arr1[total - 2].id){
                    boolean = 1;
                }    
            }
          }
          
          if(arr2[i].id == id){
            arr2.splice(i,1);
            i = i - 1;
          }
        }

        totalSel = arrSelect.length;
        for (var i = 0; i < totalSel; i++){
            if(arrSelect[i].id == id){
              arrSelect.splice(i,1);  
  
              break; 
            }
        }
          
        return true;        
    }

    pushAddArr(arrAll, Arr1, ArrPush){
        if(Arr1 == undefined){
            Arr1.unshift(ArrPush);
            arrAll.unshift(ArrPush);  
        }else{
            var  length = Arr1.length;
            Arr1.unshift(ArrPush);
            arrAll.unshift(ArrPush);  
            if (length > 10){
                Arr1.pop();
            }
    
        }
        return true;
    }

    public setCheckAll(arr, selectedArr){
        var flagCheckedAll = 0;
        var  flagAll = true;
        var totalAll = arr.length;

        var checkAll = (totalAll >= 10) ? 10: totalAll;

        for (var i = 0; i < totalAll; i++){
          if(arr[i].checked){
            flagCheckedAll += 1;
          }
        }

        var totalSelect = selectedArr.length;
        for (var i = 0; i < totalSelect; i++){
           selectedArr.pop();
        }


        
        for (var i = 0; i < arr.length; i++){
          if(flagCheckedAll >= arr.length){
            arr[i].checked = false;
            var  flagAll = false;
          }else{
            arr[i].checked = true;  
            var  flagAll = true;
            selectedArr.push(arr[i]);
          }
        }
        
        return  flagAll;
    }
      
    public printPage(currentPage, totalData, ListData){
        if(totalData){
            var firstData = 1;
            if(currentPage > 1){
                firstData = (((currentPage - 1 ) * ListData) + 1);
            }
            var LastData = ((currentPage  ) * ListData);
            if(LastData > totalData){
                LastData = totalData;
            }
            return '全' + totalData +'件('+ firstData +'-'+ LastData +'件)';  
        }
        else{
            return '';
        }
        
    }

    public unselectAll(data){
      let total = data.length;
      for(var i = 0; i < total; i++){
        if(data[i].checked){
          data[i].checked = false;
        }
      }
    }

    public updatePager(oldPager,NewPager){
        oldPager.totalItems =  NewPager.totalItems,
        oldPager.currentPage =  NewPager.currentPage,
        oldPager.pageSize =  NewPager.pageSize,
        oldPager.totalPages =  NewPager.totalPages,
        oldPager.startPage =  NewPager.startPage,
        oldPager.endPage =  NewPager.endPage,
        oldPager.startIndex =  NewPager.startIndex,
        oldPager.endIndex =  NewPager.endIndex,
        oldPager.pages =  NewPager.pages
    }

    
  public makeYear(start_year, end_year){
      var YearDate  = [];
      if(start_year == ""){
        start_year = (new Date()).getFullYear() - 2;
      }
      if(end_year == ""){
        end_year = (new Date()).getFullYear() + 20
      }

    for (var i=start_year;i<=end_year;i++){
      YearDate.push(i);
    }
    return YearDate;
  }


      
  public makeMonth(start_Month, end_Month){
    var YearDate  = [];
    if(start_Month == ""){
      start_Month = 1;
    }
    if(end_Month == ""){
      end_Month = 12;
    }

  for (var i=start_Month;i<=end_Month;i++){
    YearDate.push(i);
  }
  return YearDate;
}
public makeDay(start_Day, end_Day){
    var YearDate  = [];
    if(start_Day == ""){
      start_Day = 1;
    }
    if(end_Day == ""){
      end_Day = 12;
    }

  for (var i=start_Day;i<=end_Day;i++){
    YearDate.push(i);
  }
  return YearDate;
}


    public isValidDate(year, month, day) {    
        var d = new Date(year, month, day);
        if(month == 12){
            year = parseInt(year)*1+1*1;
            month = 0;
        }   
        day = parseInt(day);
        month = parseInt(month) ;
        year = parseInt(year);
        return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
    }

    public safeUrl(url){
        //Put http if it doesn't exist
        let prefix = 'http://';
        let prefixSafe = 'https://';
        if (url.substr(0, prefixSafe.length) !== prefixSafe)
        {
            if (url.substr(0, prefix.length) !== prefix)
            {
                url = prefix +  url;
            }
            
        }
        return url;
    }


    /** @function getPrintFromArray */

   // the above is the same as:
   /** @function
    * @name getPrintFromArray
    * 
    * @param {integer} id
    * @param {array} list array {id, name} for for display the name
    * @todo Displayinf name from set of array check by id
    *  */
  getPrintFromArray(id, arr){
    var indexData = "";
    var count = arr.length;
    for(var i = 0; i < count; i++){
      if(arr[i].id == id){
        indexData = i.toString();
      }
    }
    if(indexData == ""){
      return "";
    }else{
      return arr[indexData].name;
    }
  }

   /** @function getDataArrayByKey */

   // the above is the same as:
   /** @function
    * @name getDataArrayByKey
    * 
    * @param {integer} id
    * @param {array} list array {id, name} for for display the name
    * @param {string} key name of key that want to use
    * @todo Displayinf name from set of array check by id
    *  */
   getDataArrayByKey(id, arr, Key){
    var indexData = "";
    var count = arr.length;
    for(var i = 0; i < count; i++){
      if(arr[i].id == id){
        indexData = i.toString();
      }
    }
    if(indexData == ""){
      return "";
    }else{
      return arr[indexData][Key];
    }
  }

    /** @function getDataFromArray */
   // the above is the same as:
   /** @function
    * @name getDataFromArray
    * 
    * @param {array} list array list of array from account
    * @param {string} keyget what the value data that we want to get
    * @param {string} keycheck data nested array for check
    * @param {string} checkValue the checking value 
    * @todo get spesific data by checking spesific data
    *  */
   getDataFromArray(arrayList, keyGet, keyCheck, checkValue,callback) {
    var count = arrayList.length;
    for(var i = 0; i<count;i++){
      if(arrayList[i][keyCheck] == checkValue){
         callback(arrayList[i][keyGet]) ;
      }
    }
  }

  
   /** @function getCsvDataFile */
   // the above is the same as:
   /** @function
    * @name getCsvDataFile
    * 
    * @param {array} files array list of array from account
    * @todo get spesific data by checking spesific data
    *  */
    getCsvDataFile(events){
        return new Promise<string>((resolve, reject) => {
            const csvFiles = events.target.files || events.srcElement.files;
    
                let uploadFiles = csvFiles[0];
                let formData = new FormData();
                formData.append('csv_file', uploadFiles);
                
                var fr = new FileReader();
                fr.onload = function(e) {
                var text = fr.result;
                csv({
                    noheader:true,
                    output: "csv"
                })
                .fromString(text)
                .then((csvRow)=>{ 
                    setTimeout( () => {
                        resolve(csvRow);
                    }, 100);
                })
              
            };
            fr.readAsText(uploadFiles);
        });
    }

    /** @function seperateArray */
    // the above is the same as:
    /** @function
    * @name seperateArray
    * 
    * @param {array} files array list of array from account
    * @todo get spesific data by checking spesific data
    **/
   seperateArray(file, headerArr){
    return new Promise<any>((resolve, reject) => {
        var splitLine = file;
        var count = splitLine.length;
        var body = [];
        var header = splitLine[0];
        for(var i = 1; i < count; i++){
            var data = splitLine[i];
            if(data[0] !== ""){
                body.push(splitLine[i]);
            }
        }
        this.setHeaderAlias(header, headerArr).then( headerAlias => {
            var parseBack = {
                header : header,
                headerAlias : headerAlias,
                body : body
            }
            setTimeout( () => {
                resolve(parseBack);
            }, 100);
        });
       
    });
   }

    /** @function validateCsv */
    // the above is the same as:
    /** @function
    * @name validateCsv
    * 
    * @param {array} files array list of array from account
    * @todo get spesific data by checking spesific data
    **/
   validateCsv(events){
    return new Promise<any>((resolve, reject) => {
        const csvFiles = events.target.files || events.srcElement.files;

        let uploadFiles = csvFiles[0];
        if (uploadFiles !== undefined) {
            const fileExtention = uploadFiles.name.substring(uploadFiles.name.lastIndexOf('.') + 1).toLowerCase();
            if (uploadFiles.type == "application/vnd.ms-excel" || uploadFiles.type == "text/csv" || fileExtention == 'csv') {
                if (uploadFiles.size < 20000000) {
                    resolve(uploadFiles);
                } else {
                    reject("max size");
                }
            } else {            
                reject("wrong file type");
            }
        } else {
            reject("no data");
        }
    });
   }

    /** @function setHeaderAlias */
    // the above is the same as:
    /** @function
    * @name setHeaderAlias
    * 
    * @param {array} header array list of array from account
    * @param {array} headerAlias array list of array from account
    * @todo get spesific data by checking spesific data
    **/
   setHeaderAlias(header,headerAlias){
    return new Promise<any>((resolve, reject) => {
        var count = header.length;
        var countArr = headerAlias.length;
        var parseBack = [];
        for(var i=0; i<count;i++){
            for(var y=0; y<countArr;y++){
                if(header[i].trim() == headerAlias[y]['title'].trim()){
                    parseBack.push( headerAlias[y]['alias']);
                    break;
                }
            }
        }
        setTimeout( () => {
            resolve(parseBack);
        }, 1000);
    });
   }

    /** @function validateTrueFalse True false */
    // the above is the same as:
    /** @function
    * @name validateTrueFalse True false
    * 
    * @param {array} value array list of array for validation
    * @todo validate if the field is valid or not
    **/
   validateTrueFalse(value){
    return new Promise<any>((resolve, reject) => {

        if(value.toLowerCase().trim() == "false" || value.toLowerCase().trim() == "true"){
            resolve(true);
        }else{
            reject(false);
        }
    });
   }

    /** @function csvParsingData True false */
    // the above is the same as:
    /** @function
    * @name csvParsingData True false
    * 
    * @param {array} header array list of array for validation
    * @param {array} body array list of array for validation
    * @todo making Parsing data
    **/
   csvParsingData(header,body){
    return new Promise<any>((resolve, reject) => {
        var allArray = [];
       for(var i = 0; i<body.length;i++){
           var arr = [];
           for(var y = 0 ; y<header.length;y++){
               arr[header[y]] = body[i][y];
           }
           allArray.push(arr);
       }
       resolve(allArray);
    });
   }

    /** @function addingNewValueInArray True false */
    // the above is the same as:
    /** @function
    * @name addingNewValueInArray True false
    * 
    * @param {array} arrayData array list of array for validation
    * @param {string} valueName array list of array for validation
    * @param {string} defaultValue array list of array for validation
    * @todo adding new value in nested array
    **/
   addingNewValueInArray(arrayData, valueName, defaultValue){
    return new Promise<any>((resolve, reject) => {
        for(var i = 0 ; i<arrayData.length; i++){
            arrayData[i][valueName] = defaultValue
        }
        resolve(arrayData);
    });
   }
}


// WEBPACK FOOTER //
// ./src/app/services/pager.service.ts